import { GuestType, CalendarUnitOrder } from 'models/product';

export const sortCalendarUnit = (
  productGuestTypes: GuestType[],
  calendarUnitOrder: CalendarUnitOrder[]
): GuestType[] => {
  return productGuestTypes
    .sort((a, b) => {
      const valueA = calendarUnitOrder.findIndex(({ unit }) => unit === a.key);
      const valueB = calendarUnitOrder.findIndex(({ unit }) => unit === b.key);
      if (valueA !== -1 && valueB === -1) {
        return -1;
      }
      if (valueA === -1 && valueB !== -1) {
        return 1;
      }
      if (valueA === -1 && valueB === -1) {
        return 0;
      }
      return valueA - valueB;
    })
    .sort((a, b) => {
      const valueA =
        calendarUnitOrder.find((c) => c.unit === a.key)?.default_display_in_calendar ?? false;
      const valueB =
        calendarUnitOrder.find((c) => c.unit === b.key)?.default_display_in_calendar ?? false;
      if (valueA && !valueB) {
        return -1;
      }
      if (!valueA && valueB) {
        return 1;
      }
      return 0;
    });
};
